<!-- TelcoTrack - Login: dark teal field-ops composition -->
<div class="auth-page">
  <div class="auth-atmosphere" aria-hidden="true">
    <div class="auth-atmosphere__wash"></div>
    <div class="auth-atmosphere__grid"></div>
    <svg class="auth-atmosphere__network" viewBox="0 0 1200 800" preserveAspectRatio="xMidYMid slice">
      <defs>
        <linearGradient id="authFiberGradLogin" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="rgb(0, 168, 160)" stop-opacity="0.32" />
          <stop offset="55%" stop-color="rgb(0, 120, 120)" stop-opacity="0.2" />
          <stop offset="100%" stop-color="rgb(148, 163, 184)" stop-opacity="0.12" />
        </linearGradient>
      </defs>
      <g class="auth-fiber" fill="none" stroke="url(#authFiberGradLogin)" stroke-linecap="round">
        <path stroke-width="1.4" d="M-40 620 C180 540, 260 380, 420 340 S680 320, 820 220 S1040 80, 1240 40" />
        <path stroke-width="1.1" d="M-20 720 C200 660, 340 520, 520 470 S780 430, 960 310 S1120 160, 1280 90" />
        <path stroke-width="1" d="M60 780 C280 700, 400 580, 580 540 S840 520, 1000 400 S1160 240, 1300 180" />
        <path stroke-width="1" stroke="rgba(0, 180, 175, 0.16)" d="M-30 180 C160 240, 280 360, 420 400 S700 420, 860 500 S1060 640, 1240 720" />
      </g>
      <g class="auth-nodes" fill="rgba(0, 190, 180, 0.45)">
        <circle cx="420" cy="340" r="2.4" />
        <circle cx="820" cy="220" r="2" />
        <circle cx="520" cy="470" r="2.1" />
        <circle cx="960" cy="310" r="1.8" />
        <circle cx="860" cy="500" r="2" />
      </g>
    </svg>
    <div class="auth-atmosphere__glow"></div>
  </div>

  <div class="auth-composition">
    <header class="auth-brand">
      <img
        class="auth-brand__logo"
        src="assets/images/ProTelco.png"
        alt="ProTelco"
        width="510"
        height="148"
      />
      <p class="auth-brand__product" aria-label="TelcoTrack">
        <span class="auth-brand__product-telco">Telco</span><span class="auth-brand__product-track">Track</span>
      </p>
      <p class="auth-brand__support">
        Systém pro správu výstavby optických sítí.
      </p>
    </header>

    <section class="auth-panel" aria-label="Přihlášení">
      <form class="auth-form" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <div class="auth-form__fields">
          <app-input
            type="email"
            label="Email"
            placeholder="vas@email.cz"
            autocomplete="email"
            [required]="true"
            formControlName="email"
            [errorMessage]="getFieldError('email')">
          </app-input>

          <app-input
            type="password"
            label="Heslo"
            placeholder="Vaše heslo"
            autocomplete="current-password"
            [required]="true"
            formControlName="password"
            [errorMessage]="getFieldError('password')">
          </app-input>
        </div>

        <div *ngIf="errorMessage" class="auth-error" role="alert">
          <svg class="auth-error__icon" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
          </svg>
          <div>
            <p class="auth-error__title">Chyba při přihlašování</p>
            <p class="auth-error__body">{{ errorMessage }}</p>
          </div>
        </div>

        <app-button
          type="submit"
          variant="primary"
          [fullWidth]="true"
          [loading]="isLoading"
          [disabled]="loginForm.invalid">
          {{ isLoading ? 'Přihlašování...' : 'Přihlásit se' }}
        </app-button>

        <div class="auth-links">
          <a routerLink="/auth/forgot-password" class="auth-links__primary">
            Zapomněli jste heslo?
          </a>
          <p class="auth-links__muted">
            Nemáte účet?
            <a routerLink="/auth/register" class="auth-links__primary">Zaregistrujte se zde</a>
          </p>
          <a routerLink="/privacy" class="auth-links__subtle">
            Zásady ochrany soukromí
          </a>
        </div>
      </form>
    </section>
  </div>
</div>
